import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #1a1a1a;
  padding: 40px 0;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 0 56px 0;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 80px;
  max-width: 1369px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0;
    max-width: 340px;
    gap: 30px;
  }

  h1 {
    color: #c3c3c3;
    font-size: 32px;
    font-style: normal;
    font-weight: 275;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 32px;
    }
  }

  span {
    color: #f16024;
  }
`;

export const StyledHr = styled.hr`
  flex: 1;
  border: 1px solid #c3c3c3;
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  max-width: 1369px;
  width: 100%;
  margin: 80px auto;
  padding: 70px 20px 10px 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    margin: 24px auto 0;
    padding: 0;
    gap: 40px;
  }
`;

export const TextBox2 = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px;
  color: #fcfcfc;
  gap: 150px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0;
    gap: 0;
  }

  .grid-content {
    padding: 0 70px 0 70px;
  }

  h2 {
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
  }

  p {
    font-family: 'Open Sans';
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    margin-bottom: 10px;
    color: #c3c3c3;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 20px;
      padding-left: 10px;
    }
  }

  ul {
    font-family: 'Open Sans';
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    color: #c3c3c3;
  }

  li {
    padding-bottom: 5px;
  }

  @media (max-width: 768px) {
    text-align: left;
    margin-bottom: 0;
  }
`;

export const ImageBox = styled.div`
  flex: 1;
  text-align: center;

  img {
    max-width: 100%;
    height: auto;

    @media (max-width: 768px) {
      max-width: 90%;
    }
  }
`;
